import { MODAL_DATA_PARAM } from '../consts';

export function getModalData() {
  const raw = new URLSearchParams(window.location.search).get(MODAL_DATA_PARAM);
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
